import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function FullServiceShop() {
  const services = ['Routine maintenance and inspections', 'Brake service and suspension repair', 'Electrical system repairs', 'AC repair and climate systems', 'Transmission and fuel system repairs', 'EV service and diagnostics'];
  return <section className="py-20 px-4 bg-white" data-id="element-66">
      <div className="max-w-5xl mx-auto" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-68">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-69">
            A shop you can rely on long-term
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark mb-6" data-id="element-70">
            Once the problem is solved, we can handle everything else too.
          </h2>
          <div className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto space-y-4" data-id="element-71">
            <p data-id="element-72">
              Lancer Service is a full-service auto repair shop for most makes
              and models newer than 2007.
            </p>
            <p data-id="element-73">
              Many customers first come to us for a difficult diagnostic problem
              — and continue using Lancer for their ongoing vehicle care.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-brand-light rounded-2xl p-8 md:p-12 border border-gray-200 shadow-sm mb-12" data-id="element-74">
          <p className="font-bold text-brand-dark text-xl mb-8 text-center" data-id="element-75">
            We provide:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-76">
            {services.map((service, index) => <div key={index} className="flex items-center gap-3 bg-white p-4 rounded-xl border border-gray-100 shadow-sm" data-id="element-77">
                <CheckIcon className="w-6 h-6 text-brand-accent flex-shrink-0" data-id="element-78" />
                <span className="text-lg text-gray-800 font-medium" data-id="element-79">
                  {service}
                </span>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-80">
          <p className="text-2xl font-bold text-brand-dark" data-id="element-81">
            Our goal isn't just fixing today's issue — it's helping you keep
            your vehicle reliable for years to come.
          </p>
        </motion.div>
      </div>
    </section>;
}